import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { StyleProp, ViewStyle } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { Button, Text } from 'react-native-paper';

import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

const makeStyles = () =>
  StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      padding: 32
    }
  });

type Props = {
  onRetry: () => void;
  title?: string;
  subtitle?: string;
  style?: StyleProp<ViewStyle>;
};

export const ErrorStateView: FC<Props> = ({
  onRetry,
  title,
  subtitle,
  style
}) => {
  const styles = useMemo(() => makeStyles(), []);
  const { t } = useTranslation(LocalizationNameSpace.POSTS, {
    keyPrefix: 'screens.post-feed.state.error'
  });

  return (
    <View style={[styles.container, style]}>
      <Text variant="titleMedium">{title ?? t('title')}</Text>
      <Text variant="bodyMedium">{subtitle ?? t('subtitle')}</Text>
      <Button mode="contained-tonal" onPress={onRetry}>
        {t('retry')}
      </Button>
    </View>
  );
};
